<template>
  <Table
    class="tree-grid"
    ref="table"
    :show-header="level==1"
    :columns="tableColumns"
    :data="rows"
    @on-expand="onExpand"
    @onExpand="onExpand"
  >
    <template slot-scope="{ row }" slot="c1">
      <slot name="c1" :row="row"></slot>
    </template>
    <template slot-scope="{ row }" slot="c2">
      <slot name="c2" :row="row"></slot>
    </template>
    <template slot-scope="{ row }" slot="c3">
      <slot name="c3" :row="row"></slot>
    </template>
    <template slot-scope="{ row }" slot="c4">
      <slot name="c4" :row="row"></slot>
    </template>
    <template slot-scope="{ row }" slot="c5">
      <slot name="c5" :row="row"></slot>
    </template>
    <template slot-scope="{ row }" slot="action">
      <slot name="action" :row="row"></slot>
    </template>
  </Table>
</template>
<script>
export default {
  name: "TreeGrid",
  props: {
    columns: {
      type: Array
    },
    level: {
      type: Number,
      default: 1
    },
    maxLevel: {
      type: Number,
      default: 1
    },
    rows: {
      type: Array
    },
    formatter: {
      type: Function
    },
    childrenProperty: {
      type: String,
      default: "children"
    },
    alwayShowExpandArrow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableColumns: [],
      resize: null
    };
  },
  created() {
    this.buildData();
    // this.resize = () => {
    //   let level = this.level;
    //   let columns = this.tableColumns;
    //   let width = this.$refs.table.$el.clientWidth - 31;
    //   let autoColumnCount = 0;
    //   columns.forEach(c => {
    //     if (c.autoWidth) {
    //       autoColumnCount++;
    //     }
    //   });
    //   if (autoColumnCount > 0) {
    //     columns.forEach(c => {
    //       if (c.autoWidth) {
    //         c.width = parseInt(width / autoColumnCount);
    //       }
    //     });
    //   }
    //   if (columns.length > 1) {
    //     columns[1].width =
    //       (columns[1].width || 150) - (level - 1) * 20;
    //   }
    // };
    // window.addEventListener("resize", this.resize);
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.resize);
  },
  mounted() {
    this.$nextTick(function() {
      this.buildColumns();
    });
  },
  methods: {
    buildColumns() {
      let that = this;
      let level = this.level;
      let maxLevel = this.maxLevel;
      let columns = this.columns;
      let tableColumns = [];
      let width = this.$refs.table.$el.clientWidth - 31;
      let autoColumnCount = 0;
      columns.forEach(c => {
        let column = { ...c };
        tableColumns.push(column);
        if (c.width) {
          width -= c.width;
        } else {
          autoColumnCount++;
          column.autoWidth = true;
        }
      });
      if (autoColumnCount > 0) {
        tableColumns.forEach(c => {
          if (!c.width) {
            c.width = parseInt(width / autoColumnCount);
          }
        });
      }
      if (tableColumns.length > 0) {
        tableColumns[0].width =
          (tableColumns[0].width || 150) - (level - 1) * 20;
      }
      tableColumns.unshift({
        type: "expand",
        align: "center",
        width: 30 + (level - 1) * 20,
        render: (h, params) => {
          return h("TreeGrid", {
            props: {
              columns: columns,
              level: level + 1,
              maxLevel: maxLevel,
              rows: params.row[that.childrenProperty] || [],
              formatter: that.formatter,
              childrenProperty: that.childrenProperty
            },
            on: {
              onExpand: that.onExpand
            },
            scopedSlots: that.$scopedSlots
          });
        }
      });
      this.tableColumns = tableColumns;
    },
    buildData() {
      let level = this.level;
      let maxLevel = this.maxLevel;
      let formatter = this.formatter;
      this.rows.forEach(row => {
        row._level = level;
        if (level == maxLevel) {
          row._disableExpand = true;
        }
        let children = row[this.childrenProperty];
        if (!this.alwayShowExpandArrow && (!children || children.length == 0)) {
          row._disableExpand = true;
        }
        if (formatter) {
          formatter(row);
        }
      });
    },
    onExpand(row, status) {
      this.$emit("onExpand", row, status);
    }
  },
  watch: {
    rows() {
      this.buildData();
    }
  }
};
</script>
<style lang="scss" scoped>
.tree-grid /deep/ .ivu-table-expanded-cell {
  padding: 0;
  border: none;
  background-color: white;
  > .ivu-table-wrapper {
    border: none;
  }
  .ivu-table:after {
    display: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
}
</style>